<template>
  <div class="xc-home">
    <div class="xc-home-sidebar">
      <div class="xc-home-logo">
        <img
          :src="globalConfig.logo_url ? globalConfig.logo_url.value : null"
        />
      </div>
      <xc-sidebar
        :data.sync="menuList"
        label-key="name"
        id-key="id"
        @select="selectMenu"
        :urlPrefix="adminPath"
      />
    </div>
    <div class="xc-home-container">
      <div class="xc-home-header">
        <div class="xc-home-title">
          {{
            globalConfig.platform_name ? globalConfig.platform_name.value : null
          }}
        </div>
        <!-- <div class="kanban-btn" title="点击进入数据看板">
          <a :href="adminPath + '/kanban'" target="_blank" class="kanban-a"></a>
        </div> -->
        <div class="xc-home-user">
          <div class="xc-home-user-avatar">
            <img
              class="xc-home-user-avatar"
              :src="userInfo.avatar ? userInfo.avatar : default_avatar"
            />
          </div>

          <span class="xc-home-username">{{ userInfo.userName }}</span>
          <ul class="xc-setting">
            <li @click="edit">
              <!-- <span class="icon">
                                <img src="../assets/user/icon-setting.png">
                            </span> -->
              <span>账号设置</span>
            </li>
            <li @click="quit">
              <!-- <span class="icon">
                                <img src="../assets/user/icon-exit.png">
                            </span> -->
              <span>退出</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="xc-home-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import userInfo from "../api/user-info";
import moduleApi from "../api/module";
// import menuList from '../data/menu';
import user from "@/api/user";
import myLayerImport from "@/libs/myLayer";
import { mapState, mapActions, watch } from "vuex";
myLayerImport();

export default {
  name: "index",
  data() {
    return {
      pageUrl: null,
      website: "",
      menuList: [],
      adminPath: this.$config.adminPath,
      default_avatar: require("../assets/user/avatar.png"),
    };
  },
  computed: {
    ...mapState([
      "globalConfig",
      "userInfo",
      // 'userModule'
    ]),
    userMenu() {
      if (this.$store.state.userModule) {
        this.menuList = this.$store.state.userModule.menu;
      }
    },
  },
  created() {
    this.initData();
  },

  watch: {
    // 就监听触发一下
    userMenu(v) {
      // this.menuList = v;
    },
  },
  methods: {
    initData() {
      // 暂时不调用接口，缺少相关管理页面
      // moduleApi.listUserModule().then(v => {
      // this.menuList = eachMenu(v.data.menu);
      // if (this.menuList[0].children[0] && this.menuList[0].children[0].length) {
      //     this.pageUrl = this.menuList[0].children[0].url;
      // } else {
      //     this.pageUrl = this.menuList[0].url;
      // }
      // })
      // 临时使用
      // this.menuList = menuList;
      // this.pageUrl = this.adminPath + this.menuList[0].url;
    },
    selectMenu(nav) {
      // 强制更新
      // if (this.pageUrl && this.pageUrl == nav.url) {
      //     return document.querySelector('iframe').src = document.querySelector('iframe').src;
      // }

      // this.pageUrl = this.adminPath + nav.url;

      if (window.layer) layer.closeAll();

      this.$router.push(this.adminPath + nav.url);

      localStorage.pageId = nav.moduleId;
      localStorage.pageParentId = nav.pid;

      // const { fullPath } = this.$route
      // this.$router.replace({
      //     path: '/redirect' + this.adminPath + nav.url
      // })
    },
    // 退出
    quit() {
      //关闭所有layer页面
      if (myLayer) {
        myLayer.closeAll();
      }
      localStorage.removeItem("token");
      this.$router.replace(this.$config.adminPath + "/login");
    },

    // 账号设置
    edit() {
      if (myLayer) {
        myLayer.closeAll();
      }
      this.$router.push(this.adminPath + "/system/account/setting");
    },
  },
};
</script>

<style lang="scss" scoped>
// 看板按钮样式相关
.kanban-btn {
  width: 26px;
  height: 26px;
  margin-right: 55px;
  background-image: url("../assets/default.png");
  background-repeat: no-repeat;
  background-size: cover;
  cursor: pointer;
  &:hover {
    background-image: url("../assets/checked.png");
  }
  .kanban-a {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
</style>
